import { render } from "./SignupPageSVG.vue?vue&type=template&id=a76561f2"
const script = {}

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__